var map = {
	"./af/daistats.json": 478,
	"./de/daistats.json": 479,
	"./en/daistats.json": 148,
	"./es/daistats.json": 480,
	"./fa/daistats.json": 481,
	"./fr/daistats.json": 482,
	"./ga/daistats.json": 483,
	"./id/daistats.json": 484,
	"./it/daistats.json": 485,
	"./jp/daistats.json": 486,
	"./kr/daistats.json": 487,
	"./pl/daistats.json": 488,
	"./pt-br/daistats.json": 489,
	"./ro/daistats.json": 490,
	"./ru/daistats.json": 491,
	"./tr/daistats.json": 492,
	"./uk/daistats.json": 493,
	"./zh-TW/daistats.json": 494
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 477;